import React, { useState } from "react";
import styled from "styled-components";
import { graphql, useStaticQuery } from "gatsby";
import colors from "styles/colors.js";

import BtnSec from "components/global/BtnSec.js";
import mediaQuery from "styles/mediaQuery.js";

const ExtraButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.4rem;
  overflow: hidden;
  max-height: ${(props) => (props.$open ? "200px" : "0")};
  opacity: ${(props) => (props.$open ? 1 : 0)};
  transform: translateY(${(props) => (props.$open ? "0" : "-0.4rem")});
  transition: opacity 240ms ease, transform 240ms ease, max-height 240ms ease;
  pointer-events: ${(props) => (props.$open ? "auto" : "none")};
  @media all and (max-width: ${mediaQuery.tablet}){
max-height: initial;
opacity: 1;
transform: translateY(0);
pointer-events: auto;
flex-direction: row;
flex-wrap: wrap;
justify-content: center;
align-items: center;
width: 100%;
padding: 1rem;
gap: 1rem;

  & > * {
    flex: 0 0 calc(50% - 0.5rem);
    max-width: calc(50% - 0.5rem);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  }
`;

const ToggleButton = styled(BtnSec)`
  cursor: pointer;
  align-items: center;
  img {
    width: 1em;
    height: 1em;
    min-width: 1em;
    min-height: 1em;
    flex-shrink: 0;
    object-fit: contain;
    transition: transform 240ms ease;
    transform: rotate(${(props) => (props.$open ? "180deg" : "0deg")});
  }
  @media all and (max-width: ${mediaQuery.tablet}){
display: none;
  }
`;

const Wrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-end;
gap: 0.4rem;
position: absolute;
right: 0;
top: 0;

&:hover ${ToggleButton} {
  border-radius: 7rem;
}

@media all and (max-width: ${mediaQuery.tablet}){
position: relative;
}

`;

const ContactButtons = () => {
  const [isOpen, setIsOpen] = useState(false);

  const data = useStaticQuery(graphql`
    query NavQuery {
      strapiNavigation {
        Links_title
       Links {
          Link
          Name
        }
  }
    }
  `);

  const navigation = data?.strapiNavigation;

  if (!navigation) return null;

  return (
    <Wrapper
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <ToggleButton
        color={colors.purple}
        icon
        $open={isOpen}
        aria-expanded={isOpen}
        aria-controls="contact-buttons-extra"
      >
        {navigation.Links_title}
      </ToggleButton>

      <ExtraButtons id="contact-buttons-extra" $open={isOpen}>
        {navigation.Links.map((item, index) => (
          <BtnSec key={index} color={colors.purple} href={item.Link}>
            {item.Name}
          </BtnSec>
        ))}
      </ExtraButtons>
    </Wrapper>
  );
};

export default ContactButtons;
